import { Outlet } from "react-router-dom";

const LayoutLiquidity = () => {
  return <Outlet />;
};

export default LayoutLiquidity;
